



































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import HomeSlider from "../../store/entities/booking/homeSlider";
import Ajax from "../../lib/ajax";
import appconst from "../../lib/appconst";
import SinglePicture from '../../components/single-picture.vue';

@Component({
    components: { SinglePicture }
})
export default class EditHomeSlider extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    homeSlider: HomeSlider = new HomeSlider();

    save() {
        (this.$refs.homeSliderForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: "homeSlider/update",
                    data: this.homeSlider
                });
                (this.$refs.homeSliderForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.homeSliderForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.homeSlider = Util.extend(
                true,
                {},
                this.$store.state.homeSlider.editHomeSlider
            );
        }
    }
    async created(){

    }
    homeSliderRule = {
        imageUrl: [
            {
                required: true,
                message: this.L("UploadIsRequired", undefined, this.L("Picture")),
                trigger: "blur"
            }
        ],
        alt: [
            {
                type: 'string',
                max: 512,
                message: this.L("NoMoreThenLength", undefined, "Alt",'512'),
                trigger: "blur"
            }
        ],
        linkUrl: [
            {
                pattern: /^[0-9]+$/,
                message: 'ID只能是数字',
                trigger: "blur"
            }
        ],
        displayOrder: [
            {
                type: 'integer',
                trigger: "blur"
            }
        ]
    };
}
